import { Ref, computed } from 'vue';
import { useRouter } from 'vue-router';

import useTableRowSelection from '@/composables/team/useTableRowSelection';
import useAuth from '@/composables/useAuth';

export default function useTeamTable(selectableUserIds: Ref<number[]>) {
  const { currentUser, hasScope } = useAuth();
  const canEditUsers = computed(() => hasScope('write:members'));

  const {
    selectedIds: selectedUserIds,
    selectedVisibleIds,
    selectedVisibleCount: selectedCount,
    headerChecked,
    headerIndeterminate,
    toggle,
    onHeaderChecked,
    clear,
  } = useTableRowSelection<number>(selectableUserIds);

  const singleSelectedUserId = computed(() =>
    selectedVisibleIds.value.length === 1 ? selectedVisibleIds.value[0] : null,
  );

  /* Deletes */
  const isSelfSelected = computed(() =>
    selectedVisibleIds.value.includes(currentUser.value.id),
  );
  const deleteDisabled = computed(
    () => isSelfSelected.value || !canEditUsers.value,
  );

  const router = useRouter();
  async function handleEdit() {
    if (singleSelectedUserId.value)
      await router.push({
        name: 'edit_user',
        params: { user_id: singleSelectedUserId.value },
      });
    else
      await router.push({
        name: 'edit_users',
        query: { ids: selectedVisibleIds.value },
      });
  }

  async function handleDelete() {
    if (singleSelectedUserId.value)
      await router.push({
        name: 'remove_user',
        params: { user_id: singleSelectedUserId.value },
      });
    else
      await router.push({
        name: 'remove_users',
        query: { ids: selectedVisibleIds.value },
      });
  }
  return {
    canEditUsers,
    deleteDisabled,
    handleDelete,
    handleEdit,
    selectedCount,
    selectedUserIds,
    headerChecked,
    headerIndeterminate,
    toggle,
    onHeaderChecked,
    clear,
  };
}
